import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/button-list/button-list.tsx
import { forwardRef } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { jsx } from "react/jsx-runtime";
var ButtonList = forwardRef(
  (_a, ref) => {
    var _b = _a, { variant = "default", className, children } = _b, rest = __objRest(_b, ["variant", "className", "children"]);
    const Component = "div";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadProps(__spreadValues({
        className: clsx("hds-button-list", `hds-button-list--${variant}`, className),
        ref
      }, rest), {
        children
      })
    );
  }
);
ButtonList.displayName = "ButtonList";

export {
  ButtonList
};
//# sourceMappingURL=chunk-ME746XCZ.mjs.map